import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { RatingtypeModel } from 'projects/core/src/lib/models/ratingtype.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-ratingtype-new',
  templateUrl: './ratingtype-new.component.html',
  styleUrls: ['./ratingtype-new.component.scss']
})
export class RatingtypeNewComponent extends BaseForm implements OnInit {

  public form = this.fb.group({
    name_de: new UntypedFormControl('', [Validators.required]),
    name_en: new UntypedFormControl('', [Validators.required]),
    legend_de: new UntypedFormControl(''),
    legend_en: new UntypedFormControl(''),
    min_value: new UntypedFormControl('', [Validators.required, Validators.min(0)]),
    max_value: new UntypedFormControl('', [Validators.required, Validators.min(0)]),
    step: new UntypedFormControl(0.5, [Validators.required, Validators.min(0.5)]),
  }, {
    validators: [this.minMaxValidator]
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    if (this.auth.checkRightOrRedirect('admin.ratingtype.create')) {
      this.ui.setFormFocus();
    }
  }

  onCancel(): void {
    this.router.navigate(['/ratingtypes']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      this.api.saveModel('ratingtypes', null, this.form.value).subscribe({
        next: (result: any) => {
          const ratingtype = new RatingtypeModel().deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: ratingtype.getLang('name', this.transloco.getActiveLang()) }), this.transloco.translate('common.saved'));
          this.router.navigate(['/ratingtypes', ratingtype.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  private minMaxValidator(group: UntypedFormGroup): any {
    return (group.get('max_value')?.value > group.get('min_value')?.value) ? null : { minMax: true };
  }

}
